import React from "react";
import Svg, { Path } from "react-native-svg";
import AppTheme from "../../../AppTheme";

export default function TickIcon(props) {
  const size = props.size || 16;
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.7557 5.84429C13.2305 5.36952 13.0883 4.5672 12.4793 4.28445C12.1114 4.11361 11.6759 4.19077 11.389 4.47763L6.53333 9.33333L4.3443 7.1443C4.05744 6.85744 3.62196 6.78028 3.25401 6.95112C2.64501 7.23386 2.50285 8.03619 2.97763 8.51096L5.59052 11.1239C6.11122 11.6446 6.95544 11.6446 7.47614 11.1239L12.7557 5.84429Z"
        fill={AppTheme.almostBlack}
      />
    </Svg>
  );
}
